var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrLikes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6091_400842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49984 14.6667L2.21896 8.51906C1.86546 8.14423 1.59086 7.70493 1.41082 7.22623C1.23079 6.74753 1.14885 6.23881 1.16968 5.72912C1.21174 4.69974 1.66987 3.72889 2.44327 3.03012C3.21668 2.33136 4.242 1.96193 5.2937 2.00311C6.34539 2.04428 7.33729 2.49269 8.0512 3.24968C8.184 3.33653 8.34012 3.38288 8.49984 3.38288C8.65955 3.38288 8.81567 3.33653 8.94847 3.24968C9.66238 2.49269 10.6543 2.04428 11.706 2.00311C12.7577 1.96193 13.783 2.33136 14.5564 3.03012C15.3298 3.72889 15.7879 4.69974 15.83 5.72912C15.8721 6.75849 15.4946 7.76207 14.7807 8.51906L8.49984 14.6667Z",
    stroke: "#DD4242",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6091_400842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrLikes);
export default __webpack_public_path__ + "static/media/cr_likes.62f47834.svg";
export { ForwardRef as ReactComponent };